export default __webpack_public_path__ + "static/media/tnote1.a8baa0cd.jpg";